import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-iphone-frame',
  templateUrl: './iphone-frame.component.html',
  styleUrls: ['./iphone-frame.component.css']
})
export class IphoneFrameComponent implements OnInit {

  @Input()
  public imageUri: string;

  @Input()
  public background: string;

  @Input()
  public styleOverride: string;

  @Input()
  public isLoading: boolean;

  constructor() { }

  ngOnInit() {
  }

}
